import { Block } from '@aloft/toolkit-sui';

import { VacantLandSalesMapProps } from './types.ts';
import { useVacantLandSalesMap } from './useVacantLandSalesMap.ts';

export const VacantLandSalesMap = (props: VacantLandSalesMapProps) => {
  const { mapContainerRef } = useVacantLandSalesMap(props);

  return (
    <Block ref={mapContainerRef} width="100%" height="100%" className="vacant-land-sales-map" />
  );
};
